"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSubBusiness = exports.fetchOutletsForFranchise = exports.fetchOutletsForOwner = exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const outletService_1 = require("./service/outletService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)('outlet/fetch', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const outletService = new outletService_1.OutletService(Env_1.APIPATHENV);
        const response = yield outletService.fetch(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error fetching outlet');
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('outlet/create', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const outletService = new outletService_1.OutletService(Env_1.APIPATHENV);
        const response = yield outletService.create(payload);
        return response;
    }
    catch (error) {
        throw new Error(error.response.data.message);
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('outlet/update', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const outletService = new outletService_1.OutletService(Env_1.APIPATHENV);
        const response = yield outletService.update(payload);
        return response;
    }
    catch (error) {
        throw new Error(error.response.data.message);
    }
}));
exports.fetchOutletsForOwner = (0, toolkit_1.createAsyncThunk)('outlet/fetchOutletsForOwner', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const outletService = new outletService_1.OutletService(Env_1.APIPATHENV);
        const response = yield outletService.fetchOutletsForOwner(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error fetching outlet');
    }
}));
exports.fetchOutletsForFranchise = (0, toolkit_1.createAsyncThunk)('outlet/fetchOutletsForFranchise', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const outletService = new outletService_1.OutletService(Env_1.APIPATHENV);
        const response = yield outletService.fetchOutletsForFranchise(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error fetching outlet');
    }
}));
exports.fetchSubBusiness = (0, toolkit_1.createAsyncThunk)('outlet/fetchSubBusiness', (thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const outletService = new outletService_1.OutletService(Env_1.APIPATHENV);
        const response = yield outletService.fetchSubBusiness();
        return response;
    }
    catch (error) {
        throw new Error('Error fetching outlet');
    }
}));
